import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { COMBINED_AUDIENCES_REPORT_ID } from './combinedAudiencesReportId';

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.AUDIENCE_NAME.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.AUDIENCE_SOURCE.field,
        FIELDS.STATUS.field,
        FIELDS.AUDIENCE_CAMPAIGN_USING.field,
        FIELDS.AUDIENCE_MATCH_RATE.field,
        FIELDS.LAST_MODIFY_BY.field,
        FIELDS.LAST_MODIFY_ON.field,
    ].map(field => generateColumnId(COMBINED_AUDIENCES_REPORT_ID, field)),
};

// columns used by the 'All' column view
const defaultColumns = [
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.AUDIENCE_SOURCE.field,
    FIELDS.STATUS.field,
    FIELDS.AUDIENCE_CAMPAIGN_USING.field,
    FIELDS.AUDIENCE_MATCH_RATE.field,
    FIELDS.LAST_MODIFY_BY.field,
    FIELDS.LAST_MODIFY_ON.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(COMBINED_AUDIENCES_REPORT_ID, field));

export { customColumns, defaultColumns };
